type nestedElement = {
    value: string;
    label: string;
};

type option = {
    value: string;
    label: string;
    nested?: nestedElement[];
};

const getSelectOptions = (optionsList: option[], isPlacement: boolean) => {
    const flattened = optionsList.reduce(
        (acc: string[], currOption: option) => {
            const { nested, value } = currOption;
            if (nested) {
                for (const nestedElem of nested) {
                    const currElemValue = nestedElem.value;
                    if (isPlacement) {
                        if (typeof currElemValue == 'string') {
                            currElemValue
                                .split(',')
                                .forEach(pid => acc.push(`${value}-${pid}`));
                        } else {
                            acc.push(`${value}-${currElemValue}`);
                        }
                    } else {
                        acc.push(currElemValue);
                    }
                }
            } else {
                acc.push(value);
            }
            return acc;
        },
        [],
    );

    return flattened;
};

export default getSelectOptions;
